// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.searchBar {
    padding-bottom: 10px;
    margin-right: 10px;
}

.pl40 {
    padding-left: 40px;
}

.settingslistbox-item {
    white-space: nowrap;
}

.nodeCheckBox {
    margin-right: 8px;
    display: flex;
}

.mrl10 {
    margin-right: 10px;
    margin-left: 10px;
}

.hiddenInput {
    display: none;
}`, "",{"version":3,"sources":["webpack://./src/app/settings/versioningoverview/versioning.overview.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB","sourcesContent":[".searchBar {\n    padding-bottom: 10px;\n    margin-right: 10px;\n}\n\n.pl40 {\n    padding-left: 40px;\n}\n\n.settingslistbox-item {\n    white-space: nowrap;\n}\n\n.nodeCheckBox {\n    margin-right: 8px;\n    display: flex;\n}\n\n.mrl10 {\n    margin-right: 10px;\n    margin-left: 10px;\n}\n\n.hiddenInput {\n    display: none;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
